(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/spelpaus-react/assets/react/prescript.js') >= 0) return;  svs.modules.push('/modules/spelpaus-react/assets/react/prescript.js');
'use strict';

svs.spelpaus = svs.spelpaus || {};
svs.spelpaus.constants = svs.spelpaus.constants || {};
svs.spelpaus.pages = svs.spelpaus.pages || {};
svs.spelpaus.pages.firstPage = svs.spelpaus.pages.firstPage || {};
svs.spelpaus.pages.firstPage.components = svs.spelpaus.pages.firstPage.components || {};
svs.spelpaus.pages.svsSuspension = svs.spelpaus.pages.svsSuspension || {};
svs.spelpaus.pages.svsSuspension.components = svs.spelpaus.pages.svsSuspension.components || {};
svs.spelpaus.store = svs.spelpaus.store || {};
svs.spelpaus.store.suspension = svs.spelpaus.store.suspension || {};

svs.spelpaus.logger = new svs.core.log.Logger('module:spelpaus');

 })(window);